import React, { useContext, useEffect } from "react";
import { Route, Routes as Router, useLocation } from "react-router-dom";
import { AuthLayout } from "../components/authLayout";
import { AuthContext } from "../contexts/AuthContext";
import { AnimatedRoute } from "../components/animation";
import { SuspenseLoad } from "../components/suspense";

// ROTAS
import { TermosItens } from "../pages/termos/itens";
import { TermosCargos } from "../pages/termos/cargosLiberacao";
import { TermosFiliais } from "../pages/termos/filiaisLiberacao";
import { TermosSetores } from "../pages/termos/setoresLiberacao";
import { TermosColaboradoresLiberacao } from "../pages/termos/colaboradoresLiberacao";
import { TermosColaboradoresBloqueio } from "../pages/termos/colaboradoresBloqueio";
import { TermosConfirmacao } from "../pages/termos/confirmacao";
import { TermosRelatorio } from "../pages/termos/relatorio";
import { TermosRelatorioDetalhes } from "../pages/termos/relatorioDetalhes";

import { UniformesCadFornecedores } from "../pages/uniformes/fornecedoresCadastro";
import { UniformesCadTamanhos } from "../pages/uniformes/tamanhosCadastro";
import { UniformesCadProdutos } from "../pages/uniformes/produtosCadastro";
import { UniformesCadProdutosTamanhos } from "../pages/uniformes/produtosTamanhosCadastro";
import { UniformesCadProdutosImagens } from "../pages/uniformes/produtosImagensCadastro";
import { UniformesPedidos } from "../pages/uniformes/pedidos";
import { UniformesProdutos } from "../pages/uniformes/produtos";
import { UniformesPerfis } from "../pages/uniformes/perfis";
import { UniformesPerfisFiliais } from "../pages/uniformes/perfisFiliais";
import { UniformesCadProdutosCargos } from "../pages/uniformes/produtosCargosCadastro";
import { UniformesProdutoPedido } from "../pages/uniformes/pedido";
import { UniformesPedidosRecebidos } from "../pages/uniformes/pedidosRecebidos";
import { UniformesLotesProducao } from "../pages/uniformes/lotesProducao";
import { UniformesPedidosRecebimentos } from "../pages/uniformes/lotesPedidosRecebimentos";
import { UniformesCadEmails } from "../pages/uniformes/emailsCadastro";
import { UniformesLotesFaturamento } from "../pages/uniformes/lotesFaturamento";

import { SugestoesCadAreas } from "../pages/sugestoes/areasCadastro";
import { SugestoesCadClassificacao } from "../pages/sugestoes/classificacaoCadastro";
import { Sugestoes } from "../pages/sugestoes";
import { SugestoesDetalhamentoInicial } from "../pages/sugestoes/detalhamentoInicial";
import { SugestoesRecebidas } from "../pages/sugestoes/registrosRecebidos";
import { SugestoesAvaliacao } from "../pages/sugestoes/avaliacao";
import { SugestoesDetalhesRetorno } from "../pages/sugestoes/detalhesRetorno";
import { SugestoesCadEmails } from "../pages/sugestoes/emailsCadastro";
import { SugestoesCadSorteios } from "../pages/sugestoes/sorteiosCadastro";
import { SugestoesSorteiosItensCadastro } from "../pages/sugestoes/sorteiosItensCadastro";
import { SugestoesIndicadores } from "../pages/sugestoes/indicadores";

import { AvaliacoesCadFormularios } from "../pages/avaliacoes/formulariosCadastro";
import { AvaliacoesCadGrupos } from "../pages/avaliacoes/gruposCadstro";
import { AvaliacoesCadQuestoes } from "../pages/avaliacoes/questoesCadstro";
import { CadAvaliacoes } from "../pages/avaliacoes/cadastro";
import { AvaliacoesFormulariosCargos } from "../pages/avaliacoes/formulariosCargos";
import { AvaliacoesFormularios } from "../pages/avaliacoes/vinculoFormularios";
import { Avaliacoes } from "../pages/avaliacoes";
import { AvaliacoesLancamento } from "../pages/avaliacoes/lancamento";
import { AvaliacoesParametrosCadTipos } from "../pages/avaliacoes/parametrosTiposCadastro";
import { AvaliacoesParametrosCadGrupos } from "../pages/avaliacoes/parametrosGruposCadastro";
import { AvaliacoesParametrosGruposFiliais } from "../pages/avaliacoes/parametrosGruposFiliais";
import { AvaliacoesParametrosGruposSetores } from "../pages/avaliacoes/parametrosGruposSetores";
import { AvaliacoesParametrosGruposCargos } from "../pages/avaliacoes/parametrosGruposCargos";
import { AvaliacoesParametrosCadAvaliadores } from "../pages/avaliacoes/parametrosAvaliadoresCadastro";
import { AvaliacoesParametrosAvaliadoresCargos } from "../pages/avaliacoes/parametrosAvaliadoresCargos";
import { AvaliacoesParametrosAvaliadoresSetores } from "../pages/avaliacoes/parametrosAvaliadoresSetores";
import { AvaliacoesParametrosAvaliadoresFiliais } from "../pages/avaliacoes/parametrosAvaliadoresFiliais";
import { AvaliacoesParametrosAvaliadoresColaboradores } from "../pages/avaliacoes/parametrosAvaliadoresColaboradores";
import { AvaliacoesPerfisVisualizacao } from "../pages/avaliacoes/perfisVisualizacao";
import { AvaliacoesPerfisSetoresVisualizacao } from "../pages/avaliacoes/perfisSetoresVisualizacao";
import { AvaliacoesResultados } from "../pages/avaliacoes/resultados";
import { AvaliacoesFormulariosColaboradores } from "../pages/avaliacoes/formulariosColaboradores";
import { AvaliacoesFormulariosRelatorioPendencias } from "../pages/avaliacoes/formulariosRelatorioPendencias";
import { AvaliacoesFormulariosRelatorioPendenciasAvaliadores } from "../pages/avaliacoes/formulariosRelatorioPendenciasAvaliadores";
import { AvaliacoesResultadosDetalhes } from "../pages/avaliacoes/resultadosDetalhes";
import { AvaliacoesParametrosGruposColaboradores } from "../pages/avaliacoes/parametrosGruposColaboradores";
import { AvaliacoesSetores } from "../pages/avaliacoes/avaliadoresSetores";

import { PdiColaboradores } from "../pages/pdi/colaboradores";
import { CadPdi } from "../pages/pdi/cadastro";
import { PdiCadCompetencias } from "../pages/pdi/competenciasCadastro";
import { PdiColaborador } from "../pages/pdi";
import { PdiCadAcoes } from "../pages/pdi/acoesCadastro";
import { PdiGestaoAcoes } from "../pages/pdi/acoesGestao";
import { PdiRelatorio } from "../pages/pdi/relatorio";
import { PdiColaboradoresLiberacao } from "../pages/pdi/colaboradoresLiberacao";

import { ReciboFerias } from "../pages/reciboFerias";
import { ReciboFeriasDetalhes } from "../pages/reciboFerias/detalhes";
import { ReciboFeriasRelatorio } from "../pages/reciboFerias/relatorio";

import { AvisoFerias } from "../pages/avisoFerias";
import { AvisoFeriasDetalhes } from "../pages/avisoFerias/detalhes";
import { AvisoFeriasRelatorio } from "../pages/avisoFerias/relatorio";

import { ComprovanteRendimentos } from "../pages/comprovanteRendimentos";
import { ComprovanteRendimentosDetalhes } from "../pages/comprovanteRendimentos/detalhes";

import { CadNotificacoes } from "../pages/notificacoes/cadastro";
import { NotificacoesColaboradoresLiberacao } from "../pages/notificacoes/colaboradoresLiberacao";
import { NotificacoesColaboradoresBloqueio } from "../pages/notificacoes/colaboradoresBloqueio";
import { NotificacoesFiliais } from "../pages/notificacoes/filiaisLiberacao";
import { NotificacoesSetores } from "../pages/notificacoes/setoresLiberacao";
import { NotificacoesCargos } from "../pages/notificacoes/cargosLiberacao";
import { Notificacoes } from "../pages/notificacoes";

import { Treinamentos } from "../pages/treinamentos";
import { TreinamentosDetalhes } from "../pages/treinamentos/detalhes";
import { TreinamentosCadClassificacoes } from "../pages/treinamentos/classificacoesCadastro";
import { TreinamentosCadGrupos } from "../pages/treinamentos/gruposCadastro";
import { CadTreinamentos } from "../pages/treinamentos/treinamentosCadastro";
import { TreinamentosFiliais } from "../pages/treinamentos/filiaisLiberacao";
import { TreinamentosSetores } from "../pages/treinamentos/setoresLiberacao";
import { TreinamentosCargos } from "../pages/treinamentos/cargosLiberacao";
import { TreinamentosColaboradoresLiberacao } from "../pages/treinamentos/colaboradoresLiberacao";
import { TreinamentosColaboradoresBloqueio } from "../pages/treinamentos/colaboradoresBloqueio";
import { TreinamentosResponsaveis } from "../pages/treinamentos/responsaveis";
import { TreinamentosCadModulos } from "../pages/treinamentos/modulosCadastro";
import { TreinamentosCadFormularios } from "../pages/treinamentos/formulariosCadastro";
import { TreinamentosCadQuestoes } from "../pages/treinamentos/quesotesCadastro";
import { TreinamentosCadAlternativas } from "../pages/treinamentos/alternativasCadastro";
import { TreinamentosCadMateriais } from "../pages/treinamentos/materiaisCadastro";
import { TreinamentosLancamentoGrupos } from "../pages/treinamentos/gruposLancamento";
import { LancamentoTreinamentos } from "../pages/treinamentos/treinamentosLancamento";
import { LancamentoTreinamentosDetalhes } from "../pages/treinamentos/treinamentosLancamentoDetalhes";
import { TreinamentosLancamentoModulos } from "../pages/treinamentos/modulosLancamento";
import { TreinamentosRelatorio } from "../pages/treinamentos/relatorio";
import { TreinamentosRelatorioDetalhes } from "../pages/treinamentos/relatorioDetalhes";

import { PublicacoesCadGrupos } from "../pages/publicacoes/grupos";
import { PublicacoesGruposColaboradores } from "../pages/publicacoes/gruposColaboradores";

import { AceitesDocumentos } from "../pages/aceitesDocumentos";
import { AceitesDocumentosDetalhes } from "../pages/aceitesDocumentos/detalhes";
import { AceitesDocumentosRelatorio } from "../pages/aceitesDocumentos/relatorio";

import { ProblemasCadSistemasOrigens } from "../pages/problemas/sistemasOrigensCadastro";
import { ProblemasSistemasOrigensResponsaveis } from "../pages/problemas/sistemasOrigensPerfis";
import { ProblemasCadGrupoAvaliadores } from "../pages/problemas/grupoAvaliadoresCadastro";
import { ProblemasGrupoAvaliadoresColaboradores } from "../pages/problemas/grupoAvaliadoresColaboradores";
import { Problemas } from "../pages/problemas";
import { ProblemasResponsaveisSetores } from "../pages/problemas/responsaveisSetores";
import { ProblemasResponsaveisSetoresColaboradores } from "../pages/problemas/responsaveisSetoresColaboradores";
import { ProblemasDetalhes } from "../pages/problemas/detalhes";

import { ProblemasPerfisVisualizacao } from "../pages/problemas/perfisVisualizacao";
import { ProblemasPerfisSetoresVisualizacao } from "../pages/problemas/perfisSetoresVisualizacao";
import { ProblemasPerfisSistemasOrigemVisualizacao } from "../pages/problemas/perfisSistemasOrigemVisualizacao";
import ProblemasAcoesAcompanhamentos from "../pages/problemas/acoesAcompanhamentos";
import { AvaliacoesResultadosDescritivas } from "../pages/avaliacoes/resultadosDescritivas";
import { AvaliacoesResultadosDescritivasDetalhes } from "../pages/avaliacoes/resultadosDescritivasDetalhes";
import { EleicoesCipaCadLocalidades } from "../pages/eleicoesCipa/localidadesCadastro";
import { EleicoesCipaLocalidadesFiliais } from "../pages/eleicoesCipa/localidadesFiliais";
import { EleicoesCipaCadastro } from "../pages/eleicoesCipa/eleicoesCadastro";
import { EleicoesCipaEleicoesLocalidades } from "../pages/eleicoesCipa/eleicoesLocalidades";
import { EleicoesCipaCandidatos } from "../pages/eleicoesCipa/candidatosCadastro";
import { EleicoesCipaEleitores } from "../pages/eleicoesCipa/eleitoresManutencao";
import EleicoesCipa from "../pages/eleicoesCipa";
import { EleicoesCipaLancamento } from "../pages/eleicoesCipa/eleicoesLancamento";
import { EleicoesCipaSucesso } from "../pages/eleicoesCipa/sucesso";
import { EleicoesCipaResultados } from "../pages/eleicoesCipa/eleicoesResultados";
import { TreinamentosRelatorioCompleto } from "../pages/treinamentos/relatorioCompleto";
import { AceitesDocumentosPerfisVisualizacao } from "../pages/aceitesDocumentos/perfisVisualizacao";
import { AceitesDocumentosPerfisVisualizacaoTipos } from "../pages/aceitesDocumentos/perfisVisualizacaoTipos";
import { SatisfacaoCadCores } from "../pages/pesquisaSatisfacao/coresCadastro";
import { FormulariosColaboradoresCadFormularios } from "../pages/formulariosColaboradores/formulariosCadastro";
import { FormulariosColaboradoresCadGrupos } from "../pages/formulariosColaboradores/gruposCadastro";
import { FormulariosColaboradoresCadQuestoes } from "../pages/formulariosColaboradores/questoesCadastro";
import { FormulariosColaboradoresCadAlternativas } from "../pages/formulariosColaboradores/alternativasCadastro";
import FormulariosColaboradoresPerfis from "../pages/formulariosColaboradores/perfis";
import { FormulariosColaboradoresCampanhas } from "../pages/formulariosColaboradores/campanhasCadastro";
import { FormulariosColaboradoresCampanhasFormularios } from "../pages/formulariosColaboradores/campanhasFormularios";
import { FormulariosColaboradoresPendencias } from "../pages/formulariosColaboradores";
import { FormulariosColaboradoresLancamento } from "../pages/formulariosColaboradores/formulariosLancamento";
import { FormulariosColaboradoresCampanhasRelatorioPontuacao } from "../pages/formulariosColaboradores/campanhasRelatorioPontuacao";
import { FormulariosColaboradoresCampanhasRelatorio } from "../pages/formulariosColaboradores/campanhasRelatorio";

const Publicacoes = React.lazy(() => import("../pages/publicacoes"));
const PublicacoesColaboradores = React.lazy(() => import("../pages/publicacoes/colaboradoresLiberacao"));
const PublicacoesSetores = React.lazy(() => import("../pages/publicacoes/setoresLiberacao"));
const PublicacoesCargos = React.lazy(() => import("../pages/publicacoes/cargosLiberacao"));
const Home = React.lazy(() => import("../pages/home"));
const Beneficios = React.lazy(() => import("../pages/beneficios"));
const Vagas = React.lazy(() => import("../pages/vagas"));
const Equipamentos = React.lazy(() => import("../pages/equipamentos"));
const Perfil = React.lazy(() => import("../pages/perfil"));
const Video = React.lazy(() => import("../pages/videos"));
const CadVideos = React.lazy(() => import("../pages/videos/cadastro"));
const AlterarPerfil = React.lazy(() => import("../pages/perfil/alterar"));
const AlterarSenha = React.lazy(() => import("../pages/perfil/alterarSenha"));
const Consentimentos = React.lazy(() => import("../pages/consentimentos"));
const Agenda = React.lazy(() => import("../pages/agenda"));
const AgendaLiberacoes = React.lazy(() => import("../pages/agenda/liberacoes"));
const Termos = React.lazy(() => import("../pages/termos"));
const CadTermos = React.lazy(() => import("../pages/termos/cadastro"));
const Holerites = React.lazy(() => import("../pages/holerites"));
const HoleritesDetalhes = React.lazy(() => import("../pages/holerites/detalhes"));
const Contatos = React.lazy(() => import("../pages/contatos"));
const ContatosCadTipos = React.lazy(() => import("../pages/contatos/tiposCadastro"));
const DocumentosMarketing = React.lazy(() => import("../pages/marketing/documentos"));
const BannersMarketing = React.lazy(() => import("../pages/marketing/bannersCadastro"));
const CadPoliticaPrivacidade = React.lazy(() => import("../pages/politicaPrivacidade/cadastro"));
const PoliticaPrivacidade = React.lazy(() => import("../pages/politicaPrivacidade"));
const FinanceiroMovimentos = React.lazy(() => import("../pages/financeiro"));
const FinanceiroMovimentosMes = React.lazy(() => import("../pages/financeiro/titulos"));
const CadGrupoResponsaveis = React.lazy(() => import("../pages/grupoResponsaveis"));
const GruposResponsaveisColaboradores = React.lazy(() => import("../pages/grupoResponsaveis/colaboradores"));
const PublicacoesCadCategorias = React.lazy(() => import("../pages/publicacoes/categorias"));
const SatisfacaoCadFormularios = React.lazy(() => import("../pages/pesquisaSatisfacao/formulariosCadastro"));
const SatisfacaoFormulariosFiliais = React.lazy(() => import("../pages/pesquisaSatisfacao/filiaisLiberacao"));
const SatisfacaoFormulariosSetores = React.lazy(() => import("../pages/pesquisaSatisfacao/setoresLiberacao"));
const SatisfacaoFormulariosCargos = React.lazy(() => import("../pages/pesquisaSatisfacao/cargosLiberacao"));
const SatisfacaoFormulariosColaboradoresLiberacao = React.lazy(() =>
  import("../pages/pesquisaSatisfacao/colaboradoresLiberacao")
);
const SatisfacaoFormulariosColaboradoresBloqueio = React.lazy(() =>
  import("../pages/pesquisaSatisfacao/colaboradoresBloqueio")
);
const SatisfacaoCadQuestoes = React.lazy(() => import("../pages/pesquisaSatisfacao/questoesCadastro"));
const SatisfacaoCadAlternativas = React.lazy(() => import("../pages/pesquisaSatisfacao/alternativasCadastro"));
const SatisfacaoCadComplementos = React.lazy(() => import("../pages/pesquisaSatisfacao/complementosCadastro"));
const SatisfacaoQuestoesRelatorio = React.lazy(() => import("../pages/pesquisaSatisfacao/relatorio"));
const SatisfacaoFormulariosRelatorio = React.lazy(() => import("../pages/pesquisaSatisfacao/relatorioRealizacao"));
const SatisfacaoIndicadores = React.lazy(() => import("../pages/pesquisaSatisfacao/indicadores"));
const Education = React.lazy(() => import("../pages/perfil/escolaridade"));

function PrivateRoute() {
  const { verificarAcesso } = useContext(AuthContext);
  const location = useLocation();

  const executeScroll = () => window.scrollTo(0, 0);

  useEffect(() => {
    executeScroll();
  }, [location?.pathname]);

  return (
    <AuthLayout>
      <Router>
        <Route
          path="/perfil"
          element={
            <AnimatedRoute>
              <SuspenseLoad component={<Perfil />} />
            </AnimatedRoute>
          }
        />
        <Route
          path="/editar-perfil"
          element={
            <AnimatedRoute>
              <SuspenseLoad component={<AlterarPerfil />} />
            </AnimatedRoute>
          }
        />
        <Route
          path="/perfil/escolaridade"
          element={
            <AnimatedRoute>
              <SuspenseLoad component={<Education />} />
            </AnimatedRoute>
          }
        />
        <Route
          path="/alterar-senha"
          element={
            <AnimatedRoute>
              <SuspenseLoad component={<AlterarSenha />} />
            </AnimatedRoute>
          }
        />
        <Route
          path="/consentimentos"
          element={
            <AnimatedRoute>
              <SuspenseLoad component={<Consentimentos />} />
            </AnimatedRoute>
          }
        />
        <Route path="/recuperacao-senha" element={<AlterarSenha />} />
        <Route
          path="/politica-privacidade"
          element={
            <AnimatedRoute>
              <SuspenseLoad component={<PoliticaPrivacidade />} />
            </AnimatedRoute>
          }
        />
        <Route
          path="/termos-ciencia"
          element={
            <AnimatedRoute>
              <SuspenseLoad component={<Termos />} />
            </AnimatedRoute>
          }
        />
        <Route
          path="/termos/confirmacao/:id"
          element={
            <AnimatedRoute>
              <TermosConfirmacao />
            </AnimatedRoute>
          }
        />
        <Route
          path="/notificacoes"
          element={
            <AnimatedRoute>
              <Notificacoes />
            </AnimatedRoute>
          }
        />
        <Route
          path="*"
          element={
            <AnimatedRoute>
              <SuspenseLoad component={<Home />} />
            </AnimatedRoute>
          }
        />
        <Route
          path="/vagas"
          element={
            <AnimatedRoute>
              <SuspenseLoad component={<Vagas />} />
            </AnimatedRoute>
          }
        />
        <Route
          path="/video"
          element={
            <AnimatedRoute>
              <SuspenseLoad component={<Video />} />
            </AnimatedRoute>
          }
        />
        <Route
          path="/equipamentos"
          element={
            <AnimatedRoute>
              <SuspenseLoad component={<Equipamentos />} />
            </AnimatedRoute>
          }
        />
        {verificarAcesso("POLITICA_PRIVACIDADE_CAD") && (
          <Route
            path="/politica-privacidade/cadastro"
            element={
              <AnimatedRoute>
                <SuspenseLoad component={<CadPoliticaPrivacidade />} />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("AGENDA_VISUALIZAR") && (
          <Route
            path="/agenda"
            element={
              <AnimatedRoute>
                <SuspenseLoad component={<Agenda />} />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("AGENDA_CAD_LIBERACAO") && (
          <Route
            path="/agenda/liberacoes"
            element={
              <AnimatedRoute>
                <SuspenseLoad component={<AgendaLiberacoes />} />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("TERMO_CADASTRO") && (
          <React.Fragment>
            <Route
              path="/termos/cadastro"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<CadTermos />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/termos/itens/:id"
              element={
                <AnimatedRoute>
                  <TermosItens />
                </AnimatedRoute>
              }
            />
            <Route
              path="/termos/cargos/:id"
              element={
                <AnimatedRoute>
                  <TermosCargos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/termos/filiais/:id"
              element={
                <AnimatedRoute>
                  <TermosFiliais />
                </AnimatedRoute>
              }
            />
            <Route
              path="/termos/setores/:id"
              element={
                <AnimatedRoute>
                  <TermosSetores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/termos/colaboradores/:id"
              element={
                <AnimatedRoute>
                  <TermosColaboradoresLiberacao />
                </AnimatedRoute>
              }
            />
            <Route
              path="/termos/colaboradores-bloqueio/:id"
              element={
                <AnimatedRoute>
                  <TermosColaboradoresBloqueio />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("TERMO_RELATORIO") && (
          <>
            <Route
              path="/termos/relatorio/:id_termo"
              element={
                <AnimatedRoute>
                  <TermosRelatorio />
                </AnimatedRoute>
              }
            />
            <Route
              path="/termos/relatorio/:id_termo/detalhes/:id_filial"
              element={
                <AnimatedRoute>
                  <TermosRelatorioDetalhes />
                </AnimatedRoute>
              }
            />
          </>
        )}
        {verificarAcesso("PEDIDO_UNIFORMES_PEDIDO") && (
          <React.Fragment>
            <Route
              path="/uniformes/pedidos"
              element={
                <AnimatedRoute>
                  <UniformesPedidos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/uniformes/produtos"
              element={
                <AnimatedRoute>
                  <UniformesProdutos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/uniformes/produtos/pedido/:id_produto/:tipo/:id_solicitante"
              element={
                <AnimatedRoute>
                  <UniformesProdutoPedido />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("PEDIDO_UNIFORMES_CAD_TAMANHOS") && (
          <Route
            path="/uniformes/tamanhos"
            element={
              <AnimatedRoute>
                <UniformesCadTamanhos />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("PEDIDO_UNIFORMES_CAD_EMAIL") && (
          <Route
            path="/uniformes/gestao-emails"
            element={
              <AnimatedRoute>
                <UniformesCadEmails />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("PEDIDO_UNIFORMES_CAD_FORNECEDOR") && (
          <Route
            path="/uniformes/fornecedores"
            element={
              <AnimatedRoute>
                <UniformesCadFornecedores />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("PEDIDO_UNIFORMES_CAD_PERFIL") && (
          <React.Fragment>
            <Route
              path="/uniformes/perfis"
              element={
                <AnimatedRoute>
                  <UniformesPerfis />
                </AnimatedRoute>
              }
            />
            <Route
              path="/uniformes/perfis/filiais/:id"
              element={
                <AnimatedRoute>
                  <UniformesPerfisFiliais />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("PEDIDO_UNIFORMES_CAD_PRODUTOS") && (
          <React.Fragment>
            <Route
              path="/uniformes/gestao-produtos"
              element={
                <AnimatedRoute>
                  <UniformesCadProdutos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/uniformes/gestao-produtos/tamanhos/:id"
              element={
                <AnimatedRoute>
                  <UniformesCadProdutosTamanhos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/uniformes/gestao-produtos/imagens/:id"
              element={
                <AnimatedRoute>
                  <UniformesCadProdutosImagens />
                </AnimatedRoute>
              }
            />
            <Route
              path="/uniformes/gestao-produtos/cargos/:id"
              element={
                <AnimatedRoute>
                  <UniformesCadProdutosCargos />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("PEDIDO_UNIFORMES_LOTE_PRODUCAO") && (
          <React.Fragment>
            <Route
              path="/uniformes/pedidos-recebidos"
              element={
                <AnimatedRoute>
                  <UniformesPedidosRecebidos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/uniformes/lotes-producao"
              element={
                <AnimatedRoute>
                  <UniformesLotesProducao />
                </AnimatedRoute>
              }
            />
            <Route
              path="/uniformes/pedidos-recebidos/:id_lote"
              element={
                <AnimatedRoute>
                  <UniformesPedidosRecebimentos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/uniformes/lotes-faturamento"
              element={
                <AnimatedRoute>
                  <UniformesLotesFaturamento />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("INOVA_CAD_AREAS") && (
          <Route
            path="/sugestoes/areas"
            element={
              <AnimatedRoute>
                <SugestoesCadAreas />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("INOVA_CAD_CLASSIFICACAO") && (
          <Route
            path="/sugestoes/classificacao"
            element={
              <AnimatedRoute>
                <SugestoesCadClassificacao />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("INOVA_INDICADORES") && (
          <Route
            path="/sugestoes/indicadores"
            element={
              <AnimatedRoute>
                <SugestoesIndicadores />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("INOVA_SORTEIO") && (
          <React.Fragment>
            <Route
              path="/sugestoes/sorteios"
              element={
                <AnimatedRoute>
                  <SugestoesCadSorteios />
                </AnimatedRoute>
              }
            />
            <Route
              path="/sugestoes/sorteios/itens/:id_sorteio"
              element={
                <AnimatedRoute>
                  <SugestoesSorteiosItensCadastro />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("INOVA_CAD_EMAIL") && (
          <Route
            path="/sugestoes/gestao-emails"
            element={
              <AnimatedRoute>
                <SugestoesCadEmails />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("INOVA_LANCAMENTO") && (
          <React.Fragment>
            <Route
              path="/sugestoes"
              element={
                <AnimatedRoute>
                  <Sugestoes />
                </AnimatedRoute>
              }
            />
            <Route
              path="/sugestoes/detalhamento-inicial/:id_sugestao"
              element={
                <AnimatedRoute>
                  <SugestoesDetalhamentoInicial />
                </AnimatedRoute>
              }
            />
            <Route
              path="/sugestoes/detalhes/:id_sugestao"
              element={
                <AnimatedRoute>
                  <SugestoesDetalhesRetorno />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("INOVA_SUGESTOES_RECEBIDAS") && (
          <React.Fragment>
            <Route
              path="/sugestoes-recebidas"
              element={
                <AnimatedRoute>
                  <SugestoesRecebidas />
                </AnimatedRoute>
              }
            />
            <Route
              path="/sugestoes/avaliacao/:id_sugestao"
              element={
                <AnimatedRoute>
                  <SugestoesAvaliacao />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("CONTATOS_CAD_TIPOS") && (
          <Route
            path="/contatos/tipos"
            element={
              <AnimatedRoute>
                <SuspenseLoad component={<ContatosCadTipos />} />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("CONTATOS_LISTA") && (
          <Route
            path="/contatos"
            element={
              <AnimatedRoute>
                <SuspenseLoad component={<Contatos />} />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("PADRAO_MARKET_LISTA") && (
          <Route
            path="/marketing/documentos"
            element={
              <AnimatedRoute>
                <SuspenseLoad component={<DocumentosMarketing />} />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("MARKETING_BANNERS_CADASTRO") && (
          <Route
            path="/marketing/banners"
            element={
              <AnimatedRoute>
                <SuspenseLoad component={<BannersMarketing />} />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("AVALIACAO_CAD") && (
          <React.Fragment>
            <Route
              path="/avaliacoes/formularios"
              element={
                <AnimatedRoute>
                  <AvaliacoesCadFormularios />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/formularios/grupos/:id_formulario"
              element={
                <AnimatedRoute>
                  <AvaliacoesCadGrupos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/formularios/grupos/:id_formulario/questoes/:id_grupo"
              element={
                <AnimatedRoute>
                  <AvaliacoesCadQuestoes />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/gestao"
              element={
                <AnimatedRoute>
                  <CadAvaliacoes />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/gestao/setores/:id_avaliacao"
              element={
                <AnimatedRoute>
                  <AvaliacoesSetores />
                </AnimatedRoute>
              }
            />

            <Route
              path="/avaliacoes/gestao/formularios/:id_avaliacao"
              element={
                <AnimatedRoute>
                  <AvaliacoesFormularios />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/gestao/formularios/:id_avaliacao/cargos/:id_avaliacao_formulario"
              element={
                <AnimatedRoute>
                  <AvaliacoesFormulariosCargos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/gestao/formularios/:id_avaliacao/colaboradores/:id_avaliacao_formulario"
              element={
                <AnimatedRoute>
                  <AvaliacoesFormulariosColaboradores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/gestao/formularios/:id_avaliacao/pendencias/:id_avaliacao_formulario"
              element={
                <AnimatedRoute>
                  <AvaliacoesFormulariosRelatorioPendencias />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/gestao/formularios/:id_avaliacao/pendencias-avaliadores/:id_avaliacao_formulario"
              element={
                <AnimatedRoute>
                  <AvaliacoesFormulariosRelatorioPendenciasAvaliadores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/parametros/tipos"
              element={
                <AnimatedRoute>
                  <AvaliacoesParametrosCadTipos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/parametros/grupos"
              element={
                <AnimatedRoute>
                  <AvaliacoesParametrosCadGrupos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/parametros/grupos/filiais/:id_grupo"
              element={
                <AnimatedRoute>
                  <AvaliacoesParametrosGruposFiliais />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/parametros/grupos/setores/:id_grupo"
              element={
                <AnimatedRoute>
                  <AvaliacoesParametrosGruposSetores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/parametros/grupos/cargos/:id_grupo"
              element={
                <AnimatedRoute>
                  <AvaliacoesParametrosGruposCargos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/parametros/grupos/colaboradores/:id_grupo"
              element={
                <AnimatedRoute>
                  <AvaliacoesParametrosGruposColaboradores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/parametros/avaliadores/:id_grupo"
              element={
                <AnimatedRoute>
                  <AvaliacoesParametrosCadAvaliadores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/parametros/avaliadores/:id_grupo/cargos/:id_avaliador"
              element={
                <AnimatedRoute>
                  <AvaliacoesParametrosAvaliadoresCargos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/parametros/avaliadores/:id_grupo/setores/:id_avaliador"
              element={
                <AnimatedRoute>
                  <AvaliacoesParametrosAvaliadoresSetores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/parametros/avaliadores/:id_grupo/filiais/:id_avaliador"
              element={
                <AnimatedRoute>
                  <AvaliacoesParametrosAvaliadoresFiliais />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/parametros/avaliadores/:id_grupo/colaboradores/:id_avaliador"
              element={
                <AnimatedRoute>
                  <AvaliacoesParametrosAvaliadoresColaboradores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/perfis"
              element={
                <AnimatedRoute>
                  <AvaliacoesPerfisVisualizacao />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/perfis/setores/:id_colaborador"
              element={
                <AnimatedRoute>
                  <AvaliacoesPerfisSetoresVisualizacao />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("AVALIACAO_RESULTADOS") && (
          <React.Fragment>
            <Route
              path="/avaliacoes/resultados_descritivas"
              element={
                <AnimatedRoute>
                  <AvaliacoesResultadosDescritivas />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/resultados"
              element={
                <AnimatedRoute>
                  <AvaliacoesResultados />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/resultados/detalhes/:id_colaborador/:id_avaliacao"
              element={
                <AnimatedRoute>
                  <AvaliacoesResultadosDetalhes />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/resultados_descritivas/detalhes/:id_avaliacao"
              element={
                <AnimatedRoute>
                  <AvaliacoesResultadosDescritivasDetalhes />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("AVALIACAO_AVALIAR") && (
          <React.Fragment>
            <Route
              path="/avaliacoes"
              element={
                <AnimatedRoute>
                  <Avaliacoes />
                </AnimatedRoute>
              }
            />
            <Route
              path="/avaliacoes/lancamento/:id_formulario_lancamento"
              element={
                <AnimatedRoute>
                  <AvaliacoesLancamento />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("AVALIACAO_PDI_GESTOR") && (
          <React.Fragment>
            <Route
              path="/pdi/colaboradores"
              element={
                <AnimatedRoute>
                  <PdiColaboradores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pdi/colaboradores/pdis/:id_colaborador"
              element={
                <AnimatedRoute>
                  <CadPdi />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pdi/colaboradores/pdis/:id_colaborador/competencias/:id_pdi"
              element={
                <AnimatedRoute>
                  <PdiCadCompetencias />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pdi/colaboradores/pdis/:id_colaborador/competencias/:id_pdi/acoes/:id_competencia"
              element={
                <AnimatedRoute>
                  <PdiGestaoAcoes />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pdi/colaboradores/pdis/:id_colaborador/colaboradores-liberacao/:id_pdi"
              element={
                <AnimatedRoute>
                  <PdiColaboradoresLiberacao />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pdi/relatorio"
              element={
                <AnimatedRoute>
                  <PdiRelatorio />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("AVALIACAO_PDI") && (
          <React.Fragment>
            <Route
              path="/pdi"
              element={
                <AnimatedRoute>
                  <PdiColaborador />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pdi/acoes/:id_competencia"
              element={
                <AnimatedRoute>
                  <PdiCadAcoes />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("DOC_RH_RECIBO") && (
          <React.Fragment>
            <Route
              path="/recibo-ferias"
              element={
                <AnimatedRoute>
                  <ReciboFerias />
                </AnimatedRoute>
              }
            />
            <Route
              path="/recibo-ferias/detalhes/:id_recibo_ferias"
              element={
                <AnimatedRoute>
                  <ReciboFeriasDetalhes />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("DOC_RH_RECIBO_CONFIRM") && (
          <Route
            path="/recibo-ferias/relatorio"
            element={
              <AnimatedRoute>
                <ReciboFeriasRelatorio />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("DOC_RH_AVISO_FER") && (
          <React.Fragment>
            <Route
              path="/aviso-ferias"
              element={
                <AnimatedRoute>
                  <AvisoFerias />
                </AnimatedRoute>
              }
            />
            <Route
              path="/aviso-ferias/detalhes/:id_aviso_ferias"
              element={
                <AnimatedRoute>
                  <AvisoFeriasDetalhes />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("DOC_RH_AVISO_FER_CONFIRM") && (
          <Route
            path="/aviso-ferias/relatorio"
            element={
              <AnimatedRoute>
                <AvisoFeriasRelatorio />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("DOC_RH_INF_REND") && (
          <React.Fragment>
            <Route
              path="/comprovante-rendimentos"
              element={
                <AnimatedRoute>
                  <ComprovanteRendimentos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/comprovante-rendimentos/detalhes/:id_comprovante_rendimentos"
              element={
                <AnimatedRoute>
                  <ComprovanteRendimentosDetalhes />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso(["HOLERITE"]) && (
          <React.Fragment>
            <Route
              path="/holerites"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<Holerites />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/holerites/detalhes/:id_holerite"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<HoleritesDetalhes />} />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso(["NOTIFICACOES_CAD"]) && (
          <React.Fragment>
            <Route
              path="/notificacoes/cadastro"
              element={
                <AnimatedRoute>
                  <CadNotificacoes />
                </AnimatedRoute>
              }
            />
            <Route
              path="/notificacoes/colaboradores/:id_notificacao"
              element={
                <AnimatedRoute>
                  <NotificacoesColaboradoresLiberacao />
                </AnimatedRoute>
              }
            />
            <Route
              path="/notificacoes/colaboradores-bloqueio/:id_notificacao"
              element={
                <AnimatedRoute>
                  <NotificacoesColaboradoresBloqueio />
                </AnimatedRoute>
              }
            />
            <Route
              path="/notificacoes/filiais/:id_notificacao"
              element={
                <AnimatedRoute>
                  <NotificacoesFiliais />
                </AnimatedRoute>
              }
            />
            <Route
              path="/notificacoes/setores/:id_notificacao"
              element={
                <AnimatedRoute>
                  <NotificacoesSetores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/notificacoes/cargos/:id_notificacao"
              element={
                <AnimatedRoute>
                  <NotificacoesCargos />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso(["TREINAMENTOS_RELATORIOS"]) && (
          <React.Fragment>
            <Route
              path="/treinamentos"
              element={
                <AnimatedRoute>
                  <Treinamentos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/detalhes/:id_treinamento"
              element={
                <AnimatedRoute>
                  <TreinamentosDetalhes />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso(["TREINAMENTOS_CAD"]) && (
          <React.Fragment>
            <Route
              path="/treinamentos/classificacoes"
              element={
                <AnimatedRoute>
                  <TreinamentosCadClassificacoes />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos"
              element={
                <AnimatedRoute>
                  <TreinamentosCadGrupos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo"
              element={
                <AnimatedRoute>
                  <CadTreinamentos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/filiais/:id_curso"
              element={
                <AnimatedRoute>
                  <TreinamentosFiliais />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/setores/:id_curso"
              element={
                <AnimatedRoute>
                  <TreinamentosSetores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/cargos/:id_curso"
              element={
                <AnimatedRoute>
                  <TreinamentosCargos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/colaboradores-liberacao/:id_curso"
              element={
                <AnimatedRoute>
                  <TreinamentosColaboradoresLiberacao />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/colaboradores-bloqueio/:id_curso"
              element={
                <AnimatedRoute>
                  <TreinamentosColaboradoresBloqueio />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/responsaveis/:id_curso"
              element={
                <AnimatedRoute>
                  <TreinamentosResponsaveis />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/modulos/:id_curso"
              element={
                <AnimatedRoute>
                  <TreinamentosCadModulos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/relatorio-completo/:id_curso"
              element={
                <AnimatedRoute>
                  <TreinamentosRelatorioCompleto />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/relatorio/:id_curso"
              element={
                <AnimatedRoute>
                  <TreinamentosRelatorio />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/relatorio/:id_curso/detalhes/:id_filial"
              element={
                <AnimatedRoute>
                  <TreinamentosRelatorioDetalhes />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/modulos/:id_curso/formularios/:id_modulo"
              element={
                <AnimatedRoute>
                  <TreinamentosCadFormularios />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/modulos/:id_curso/formularios/:id_modulo/questoes/:id_formulario"
              element={
                <AnimatedRoute>
                  <TreinamentosCadQuestoes />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/modulos/:id_curso/formularios/:id_modulo/questoes/:id_formulario/alternativas/:id_questao"
              element={
                <AnimatedRoute>
                  <TreinamentosCadAlternativas />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/grupos/cursos/:id_grupo/modulos/:id_curso/materiais/:id_modulo"
              element={
                <AnimatedRoute>
                  <TreinamentosCadMateriais />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso(["TREINAMENTOS_LANCAMENTO"]) && (
          <React.Fragment>
            <Route
              path="/treinamentos/lancamento/grupos"
              element={
                <AnimatedRoute>
                  <TreinamentosLancamentoGrupos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/lancamento/grupos/cursos/:id_grupo"
              element={
                <AnimatedRoute>
                  <LancamentoTreinamentos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/lancamento/grupos/cursos/:id_grupo/detalhes/:id_curso"
              element={
                <AnimatedRoute>
                  <LancamentoTreinamentosDetalhes />
                </AnimatedRoute>
              }
            />
            <Route
              path="/treinamentos/lancamento/grupos/cursos/:id_grupo/detalhes/:id_curso/modulo/:id_modulo"
              element={<TreinamentosLancamentoModulos />}
            />
          </React.Fragment>
        )}
        {verificarAcesso(["FINANCEIRO_MOVIMENTOS"]) && (
          <React.Fragment>
            <Route
              path="/financeiro"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<FinanceiroMovimentos />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/financeiro/titulos/:data/:tipo/:descricao"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<FinanceiroMovimentosMes />} />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso(["PUBLICACOES_GESTAO"]) && (
          <React.Fragment>
            <Route
              path="/publicacoes/grupos"
              element={
                <AnimatedRoute>
                  <PublicacoesCadGrupos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/publicacoes/grupos/colaboradores/:id_grupo"
              element={
                <AnimatedRoute>
                  <PublicacoesGruposColaboradores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/publicacoes/categorias"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<PublicacoesCadCategorias />} />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso(["PUBLICACOES", "PUBLICACOES_GESTAO", "PUBLICACOES_LANCAMENTO"]) && (
          <>
            <Route
              path="/publicacoes/setores/:id_publicacao"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<PublicacoesSetores />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/publicacoes/cargos/:id_publicacao"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<PublicacoesCargos />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/publicacoes/colaboradores/:id_publicacao"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<PublicacoesColaboradores />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/publicacoes"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<Publicacoes />} />
                </AnimatedRoute>
              }
            />
          </>
        )}
        {verificarAcesso("ACEITES_DOCUMENTOS") && (
          <React.Fragment>
            <Route
              path="/aceites-documentos"
              element={
                <AnimatedRoute>
                  <AceitesDocumentos />
                </AnimatedRoute>
              }
            />
            <Route
              path="/aceites-documentos/detalhes/:id_aceites_documentos"
              element={
                <AnimatedRoute>
                  <AceitesDocumentosDetalhes />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso("ACEITES_DOCUMENTOS_RELATORIO") && (
          <Route
            path="/aceites-documentos/relatorio"
            element={
              <AnimatedRoute>
                <AceitesDocumentosRelatorio />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("ACEITES_DOCUMENTOS_GESTAO") && (
          <React.Fragment>
            <Route
              path="/aceites-documentos/perfis"
              element={
                <AnimatedRoute>
                  <AceitesDocumentosPerfisVisualizacao />
                </AnimatedRoute>
              }
            />
            <Route
              path="/aceites-documentos/perfis/tipos/:id_colaborador"
              element={
                <AnimatedRoute>
                  <AceitesDocumentosPerfisVisualizacaoTipos />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
        {verificarAcesso(["BENEFICIOS", "BENEFICIOS_GESTAO"]) && (
          <Route
            path="/beneficios"
            element={
              <AnimatedRoute>
                <SuspenseLoad component={<Beneficios />} />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("VIDEOS_CAD") && (
          <Route
            path="/video/cadastro"
            element={
              <AnimatedRoute>
                <SuspenseLoad component={<CadVideos />} />
              </AnimatedRoute>
            }
          />
        )}
        {verificarAcesso("GRUPOS_RESPONSAVEIS_CAD") && (
          <React.Fragment>
            <Route
              path="/grupos-responsaveis"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<CadGrupoResponsaveis />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/grupos-responsaveis/colaboradores/:id_grupo"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<GruposResponsaveisColaboradores />} />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}

        {verificarAcesso("PLANO_ACAO_GESTAO") && (
          <React.Fragment>
            <Route
              path="/planos-acao/sistemas-origens"
              element={
                <AnimatedRoute>
                  <ProblemasCadSistemasOrigens />
                </AnimatedRoute>
              }
            />
            <Route
              path="/planos-acao/sistemas-origens/responsaveis/:id_sistemas_origens"
              element={
                <AnimatedRoute>
                  <ProblemasSistemasOrigensResponsaveis />
                </AnimatedRoute>
              }
            />
            <Route
              path="/planos-acao/grupo-avaliadores"
              element={
                <AnimatedRoute>
                  <ProblemasCadGrupoAvaliadores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/planos-acao/grupo-avaliadores/colaboradores/:id_grupo_avaliadores"
              element={
                <AnimatedRoute>
                  <ProblemasGrupoAvaliadoresColaboradores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/planos-acao/responsaveis-setores"
              element={
                <AnimatedRoute>
                  <ProblemasResponsaveisSetores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/planos-acao/responsaveis-setores/colaboradores/:id_setor"
              element={
                <AnimatedRoute>
                  <ProblemasResponsaveisSetoresColaboradores />
                </AnimatedRoute>
              }
            />
            <Route
              path="/planos-acao/perfis"
              element={
                <AnimatedRoute>
                  <ProblemasPerfisVisualizacao />
                </AnimatedRoute>
              }
            />
            <Route
              path="/planos-acao/perfis/setores/:id_colaborador"
              element={
                <AnimatedRoute>
                  <ProblemasPerfisSetoresVisualizacao />
                </AnimatedRoute>
              }
            />
            <Route
              path="/planos-acao/perfis/sistemas-origem/:id_colaborador"
              element={
                <AnimatedRoute>
                  <ProblemasPerfisSistemasOrigemVisualizacao />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}

        {verificarAcesso(["PLANO_ACAO_LANCAMENTO", "PLANO_ACAO_RELATORIOS", "PLANO_ACAO_AVALIACAO"]) && (
          <React.Fragment>
            <Route path="/planos-acao" element={<Problemas />} />
            <Route
              path="/planos-acao/detalhes/:id_problema"
              element={
                <AnimatedRoute>
                  <ProblemasDetalhes tab="1" />
                </AnimatedRoute>
              }
            />
            <Route
              path="/planos-acao/detalhes/:id_problemas/acompanhamentos/:id_problemas_acoes"
              element={
                <AnimatedRoute>
                  <ProblemasAcoesAcompanhamentos />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}

        {verificarAcesso(["PLANO_ACAO_AVALIACAO", "PLANO_ACAO_RELATORIOS"]) && (
          <React.Fragment>
            <Route path="/planos-acao/relatorio/detalhes/:id_problema" element={<ProblemasDetalhes tab="3" />} />
            <Route path="/planos-acao/avaliacoes/detalhes/:id_problema" element={<ProblemasDetalhes tab="2" />} />
          </React.Fragment>
        )}

        {verificarAcesso(["ELEICOES_CIPA_GESTAO"]) && (
          <React.Fragment>
            <Route path="/eleicoes-cipa/localidades" element={<EleicoesCipaCadLocalidades to="/" />} />
            <Route
              path="/eleicoes-cipa/localidades/filiais/:id_localidade"
              element={<EleicoesCipaLocalidadesFiliais to="/eleicoes-cipa/localidades" />}
            />
            <Route path="/eleicoes-cipa/eleicoes" element={<EleicoesCipaCadastro to="/" />} />
            <Route
              path="/eleicoes-cipa/eleicoes/localidades/:id_eleicoes"
              element={<EleicoesCipaEleicoesLocalidades to="/eleicoes-cipa/eleicoes" />}
            />
            <Route
              path="/eleicoes-cipa/eleicoes/eleitores/:id_eleicoes"
              element={<EleicoesCipaEleitores to="/eleicoes-cipa/eleicoes" />}
            />

            <Route
              path="/eleicoes-cipa/eleicoes/resultados/:id_eleicoes"
              element={<EleicoesCipaResultados to="/eleicoes-cipa/eleicoes" />}
            />

            <Route
              path="/eleicoes-cipa/eleicoes/localidades/:id_eleicoes/candidatos/:id_eleicoes_localidades"
              element={<EleicoesCipaCandidatos to={"/eleicoes-cipa/eleicoes/localidades"} />}
            />
          </React.Fragment>
        )}

        {verificarAcesso(["ELEICOES_CIPA_LANCAMENTO"]) && (
          <React.Fragment>
            <Route path="/eleicoes-cipa" element={<EleicoesCipa to="/" />} />
            <Route
              path="/eleicoes-cipa/lancamento/:id_eleicoes_lancamento"
              element={<EleicoesCipaLancamento to="/eleicoes-cipa" />}
            />
            <Route path="/eleicoes-cipa/sucesso" element={<EleicoesCipaSucesso to="/" />} />
          </React.Fragment>
        )}

        {verificarAcesso(["FORMULARIOS_COLABORADORES_CADASTROS"]) && (
          <React.Fragment>
            <Route path="/formularios-colaboradores/formularios" element={<FormulariosColaboradoresCadFormularios />} />
            <Route
              path="/formularios-colaboradores/formularios/perfis/:id_cad_formularios"
              element={<FormulariosColaboradoresPerfis />}
            />
            <Route
              path="/formularios-colaboradores/formularios/grupos/:id_cad_formularios"
              element={<FormulariosColaboradoresCadGrupos />}
            />
            <Route
              path="/formularios-colaboradores/formularios/grupos/:id_cad_formularios/questoes/:id_cad_grupos"
              element={<FormulariosColaboradoresCadQuestoes />}
            />
            <Route
              path="/formularios-colaboradores/formularios/grupos/:id_cad_formularios/questoes/:id_cad_grupos/alternativas/:id_cad_questoes"
              element={<FormulariosColaboradoresCadAlternativas />}
            />
          </React.Fragment>
        )}

        {verificarAcesso(["FORMULARIOS_COLABORADORES"]) && (
          <React.Fragment>
            <Route path="/formularios-colaboradores/pencencias" element={<FormulariosColaboradoresPendencias />} />
            <Route
              path="/formularios-colaboradores/pencencias/lancamento/:id_formularios_lancamento"
              element={<FormulariosColaboradoresLancamento />}
            />
          </React.Fragment>
        )}

        {verificarAcesso(["FORMULARIOS_COLABORADORES_GESTAO"]) && (
          <React.Fragment>
            <Route path="/formularios-colaboradores/campanhas" element={<FormulariosColaboradoresCampanhas />} />
            <Route
              path="/formularios-colaboradores/campanhas/colaboradores/:id_campanhas"
              element={<FormulariosColaboradoresCampanhasFormularios />}
            />
            <Route
              path="/formularios-colaboradores/campanhas/relatorio-pontuacao/:id_campanhas"
              element={<FormulariosColaboradoresCampanhasRelatorioPontuacao />}
            />
            <Route
              path="/formularios-colaboradores/campanhas/relatorio/:id_campanhas"
              element={<FormulariosColaboradoresCampanhasRelatorio />}
            />
          </React.Fragment>
        )}

        {verificarAcesso("SATISFACAO_GESTAO") && (
          <React.Fragment>
            <Route
              path="/pesquisa-satisfacao/formularios"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoCadFormularios />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/formularios/filiais/:id_formulario"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoFormulariosFiliais />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/formularios/setores/:id_formulario"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoFormulariosSetores />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/formularios/cargos/:id_formulario"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoFormulariosCargos />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/formularios/colaboradores/:id_formulario"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoFormulariosColaboradoresLiberacao />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/formularios/colaboradores-bloqueios/:id_formulario"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoFormulariosColaboradoresBloqueio />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/formularios/questoes/:id_formulario"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoCadQuestoes />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/formularios/questoes/:id_formulario/alternativas/:id_questao"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoCadAlternativas />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/formularios/questoes/:id_formulario/alternativas/:id_questao/complementos/:id_alternativa"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoCadComplementos />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/formularios/questoes/:id_formulario/relatorios/:id_questao"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoQuestoesRelatorio />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/formularios/relatorio/:id_formulario"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoFormulariosRelatorio />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/indicadores"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoIndicadores />} />
                </AnimatedRoute>
              }
            />
            <Route
              path="/pesquisa-satisfacao/cores"
              element={
                <AnimatedRoute>
                  <SuspenseLoad component={<SatisfacaoCadCores />} />
                </AnimatedRoute>
              }
            />
          </React.Fragment>
        )}
      </Router>
    </AuthLayout>
  );
}

export { PrivateRoute };
